import { render } from "./StartProfile.vue?vue&type=template&id=5060249a"
import script from "./StartProfile.vue?vue&type=script&lang=js"
export * from "./StartProfile.vue?vue&type=script&lang=js"

import "./StartProfile.vue?vue&type=style&index=0&id=5060249a&lang=css"
script.render = render

export default script